<template>
    <v-container fluid>
        <v-layout style="display: block;">
            <consultations-and-reworks-index/>
        </v-layout>
    </v-container>
</template>

<script>

    import ConsultationsAndReworksIndex
        from "../../components/student/consultationsAndReworks/ConsultationsAndReworksIndex";

    export default {
        components: {
            ConsultationsAndReworksIndex,
        }
    }
</script>